import { render } from "./CustomDnaCardUploader.vue?vue&type=template&id=1d7071f0"
import script from "./CustomDnaCardUploader.vue?vue&type=script&lang=js"
export * from "./CustomDnaCardUploader.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__